// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7f5fb0", // Your purple brand color
      contrastText: "#FFFFFF", // White text for contrast
    },
    secondary: {
      main: "#9575CD", // Lighter purple accent
    },
    background: {

    },
  },
  typography: {
    fontFamily: "Arial, sans-serif", 
    button: {
      textTransform: "none", 
    },
  },
    MuiDrawer: {
      styleOverrides: {
        paper: {
        //   backgroundColor: "#512DA8", // Sidebar background purple
        //   color: "#FFFFFF", // White text in sidebar
        },
      },
    },

});

export default theme;